import {
  Edit,
  SimpleForm,
  TextInput,
  PasswordInput,
  BooleanInput,
  ReferenceArrayInput,
  SelectArrayInput,
} from "react-admin";
import {
  hasValue
} from "../../utils/schemas";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid } from "@mui/material";
import EditTitle from "../../ui/edit-title";
import CustomSaveToolbar from "../../ui/custom-save-toolbar";

const Schema = Yup.object(
{
  name: hasValue()
});

const EnterpriseAdminEdit = () =>
{
  return (
    <Edit
      title={<EditTitle subtitle="Editar Usuário Admin Empresa: " source="name" />}
      redirect="list"
      mutationMode="pessimistic" >
      <SimpleForm
        noValidate
        resolver={yupResolver(Schema)}
        toolbar={<CustomSaveToolbar />} >
        <Grid container columnSpacing={2} width="100%">
          <Grid size={{ xs: 1 }}>
            <TextInput source="id" label="Id" fullWidth disabled />
          </Grid>
          <Grid size={{ xs: 5 }}>
            <TextInput source="enterprise_name" label="Empresa" fullWidth disabled />
          </Grid>
          <Grid size={{ xs: 6 }} />

          <Grid size={{ xs: 6 }}>
            <TextInput source="name" label="Nome" fullWidth isRequired />
          </Grid>
          <Grid size={{ xs: 6 }} />

          <Grid size={{ xs: 3 }}>
            <TextInput source="email" label="E-mail" fullWidth disabled />
          </Grid>
          <Grid size={{ xs: 3 }}>
            <PasswordInput source="password" label="Senha" fullWidth  />
          </Grid>
          <Grid size={{ xs: 6 }} />

          <Grid size={{ xs: 6 }}>
            <ReferenceArrayInput source="permissions_id" sort={{ field: "name", order: "ASC" }} reference="setup/enterprise-permissions">
              <SelectArrayInput label="Permissão(ões)" optionText="name" optionValue="id" fullWidth />
            </ReferenceArrayInput>
          </Grid>
          <Grid size={{ xs: 6 }} />

          <Grid size={{ xs: 6 }}>
            <BooleanInput source="active" label="Ativo" />
          </Grid>
          <Grid size={{ xs: 6 }} />
        </Grid>
      </SimpleForm>
    </Edit>
  );
};

export default EnterpriseAdminEdit;
